import { http } from '@/plugins/http/index';
import { getData } from '@/utils/get';

export const get = () => http.get('volunteers').then(getData);

export const view = (id) => http.get(`volunteers/${id}`).then(getData);

export const getVolunteersByDate = (id) => http.get(`volunteers/bydate/${id}`).then(getData);
